import { Controller } from "@hotwired/stimulus"
import React, { Suspense } from "react"
import { render } from "react-dom"
import NewPortfolio from "web/app/Portfolios/NewPortfolio"
import { Loading } from "web/components"
import { AppProviders, LibraryProviders } from "web/Providers"
import routes from "web/routes/constants"

export default class NewPortfolioController extends Controller {
  static outlets = ["react-portfolios-object-list"]

  initialize() {
    global.React = React
  }

  async handleAddPortfolio(portfolioData) {
    const portfolios = this.reactPortfoliosObjectListOutlet.portfolios

    const newPortfolio = await portfolios.add(portfolioData)

    if (newPortfolio !== undefined) {
      this.#navigateToNewPortfolios(newPortfolio)
    }
  }

  connect() {
    render(
      <Suspense fallback={<Loading />}>
        <LibraryProviders>
          <AppProviders>
            <NewPortfolio
              close={() => {}}
              handleAddPortfolio={this.handleAddPortfolio.bind(this)}
            />
          </AppProviders>
        </LibraryProviders>
      </Suspense>,
      this.element
    )
  }

  #navigateToNewPortfolios(portfolio) {
    const viewGroup = this.reactPortfoliosObjectListOutlet.viewGroupValue
    const viewId = this.reactPortfoliosObjectListOutlet.viewIdValue

    window.Turbo.visit(routes.portfolio(viewGroup.slug, viewId, portfolio.id))
  }
}
